var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58172 0 0 3.58173 0 8C0 12.4183 3.58172 16 8 16ZM6.13553 11.2426L6.13422 11.2413L3.72745 8.83456C3.33692 8.44403 3.33692 7.81087 3.72745 7.42035C4.11797 7.02983 4.75114 7.02983 5.14166 7.42035L6.84264 9.12132L11.0853 4.87868C11.4758 4.48816 12.109 4.48816 12.4995 4.87868C12.89 5.26921 12.89 5.90237 12.4995 6.29289L7.55093 11.2415L7.54975 11.2426C7.20804 11.5844 6.68056 11.6271 6.2924 11.3708C6.23695 11.3342 6.18435 11.2915 6.13553 11.2426Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f5a097522a95cdbc3ee4ba29d2078514.svg";
export { ForwardRef as ReactComponent };